import { z } from 'zod';

export const zodInvoiceForwardingReasonSchema = z.object({
  reasonCode: z.number(),
  reasonText: z.string(),
});

export const zodInvoiceForwardingReasonsResponseSchema = z.object({
  reasons: z.array(zodInvoiceForwardingReasonSchema),
});

export const zodInvoiceForwardingReasonsEndpointSchema = z.tuple([
  z.literal('invoice'),
  z.literal('process'),
  z.uuid(),
  z.literal('forward-reasons'),
]);
